// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remove-line-component .content-area .subtitle{color:#7b8794;font-size:16px}.remove-line-component .content-area .lines-container{margin-top:30px;padding-left:30px}.remove-line-component .content-area .lines-container .line{color:#013893}.remove-line-component .content-area .lines-container .line .text{font-size:14px;margin-left:5px;font-family:'OpenSans';color:#1f2933}.buttons .danger-button{margin-left:15px}\n", ""]);
// Exports
module.exports = exports;
